import Model from './Model'

export default class FivePercentRuleModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'fivePercentRules'
  }
}
